<!--
 * @Copyright: Copyright (c) 2021 Yihua, All right is reserverd
 * @name: Header
 * @Description: 头部组件
 * @FilePath: \web_manage_globalf:\work\web\app-tikfriend_web\src\components\NavBar.vue
 * @Version: 0.1.0
 * @Autor: hselenat
 * @Date: 2021-04-27 16:07:25
 * @LastEditors: syl
 * @LastEditTime: 2022-05-26 18:01:43
 * @example: 调用示例
-->
<template>
  <div class="nav-x">
    <div class="nav-contain">
      <!-- <img src="../assets/lishi_logo.png" alt="互勾" class="hg-logo"> -->
      <p class="hg-logo-title">砾鹰石</p>
      <div class="nav-platform">
        <ul>
          <li v-for="(item, index) in navItems" :key="index" :class="index == curSelectId ? 'active' : ''"
            @click="handlerLi(item, index)">
            <pre>{{ item.compTitle }}</pre>
            <div class="tab-line"></div>
          </li>
        </ul>
        <img src="../assets/nav_hamburger.png" alt="汉堡包" class="nav-mobile" @click="showMobileNav(true)">
      </div>
    </div>
    <div class="mobile-x" v-if="isShowMobile == true">
      <img src="../assets/nav_close.png" alt="汉堡包" class="nav-close" @click="showMobileNav(false)">
      <ul>
        <li v-for="(item, index) in navItems" :key="index" :class="index == curSelectId ? 'active' : ''"
          @click="handlerLi(item, index)">
          <pre>{{ item.compTitle }}</pre>
          <div class="tab-line"></div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  props: {
    selectId: {
      type: Number
    }
  },
  data() {
    return {
      isShowMobile: false,
      navItems: [
        // {
        //   compName: "home",
        //   compTitle: "益华集团介绍"
        // },
        {
          id: 0,
          compName: "team",
          compTitle: "砾鹰石企业"
        },
        {
          id: 1,
          compName: "chat",
          compTitle: "互勾·聊天"
        },
        // {
        //   id: 2,
        //   compName: "work",
        //   compTitle: "互勾·办公"
        // },
        // {
        //   id: 3,
        //   compName: "monitor",
        //   compTitle: "互勾·监控"
        // },
        // {
        //   compName: "comment",
        //   compTitle: "互勾动态"
        // },
        // {
        //   compName: "goudrive",
        //   compTitle: "互勾收藏"
        // },
        {
          id: 4,
          compName: "joinus",
          compTitle: "人才招聘"
        }
      ],
      curSelectId: 0
    };
  },
  created() {
    this.curSelectId = this.selectId
  },
  methods: {
    handlerLi(item, index) {
      console.log("=======12121212>", item, '==handlerLi==>', index)
      this.curSelectId = index;
      this.isShowMobile = false
      this.$emit("handlerLi", item);
    },
    showMobileNav(showType) {
      this.isShowMobile = showType
    }
  }
};
</script>
